module.exports = __webpack_public_path__ + "static/resilient_e-4d168a17c708cfb7b96d41f1bbfb1000.svg";